// NOTE: This file must remain a JS file because
// it's used in `vite.config.js`

export const VERSION = '4.2.1'
export const RELEASE_TIME = 1785994214881
